// Copyright 2025, University of Maryland, All Rights Reserved
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui'

interface DashboardPaginationProps {
  currentPageIndex: number
  pageCountEstimate?: number
  rowsOnPage: number
  totalCount: number
  loading?: boolean
  hasPreviousPage: boolean
  canGoNext: boolean
  onPrevious: () => void
  onNext: () => void
}

export const DashboardPagination: React.FC<DashboardPaginationProps> = ({
  currentPageIndex,
  pageCountEstimate,
  rowsOnPage,
  totalCount,
  loading = false,
  hasPreviousPage,
  canGoNext,
  onPrevious,
  onNext,
}) => {
  return (
    <div className="flex items-center justify-between text-sm text-slate-600">
      <span>
        Page {currentPageIndex + 1}
        {pageCountEstimate ? ` of ${pageCountEstimate}` : ''} • Showing {rowsOnPage} of {totalCount} document{totalCount === 1 ? '' : 's'}
      </span>
      <div className="flex items-center gap-1 mr-10">
        <Button
          variant="ghost"
          size="sm"
          onClick={onPrevious}
          disabled={!hasPreviousPage || loading}
          className="gap-1 text-slate-600 hover:text-slate-800"
        >
          <ChevronLeft className="h-4 w-4" />
          Previous
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={onNext}
          disabled={!canGoNext || loading}
          className="gap-1 text-slate-600 hover:text-slate-800"
        >
          Next
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
